import { useMemo } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import {
  buildBreadcrumbSchema,
  buildFaqSchema,
  buildLocalBusinessSchema,
  getDefaultBreadcrumbs,
  getPageSeo,
} from '../Utils/seoConfig';
import { PAGE_FAQ } from '../Utils/seoFaq';

export const useStaticSeo = (pageKey, path, breadcrumbs = null) => {
  const { locale } = useLanguage();

  return useMemo(() => {
    const seo = getPageSeo(pageKey, locale);
    const crumbs = breadcrumbs || getDefaultBreadcrumbs(pageKey, locale);
    const jsonLd = [];

    if (crumbs?.length) {
      jsonLd.push(buildBreadcrumbSchema(crumbs));
    }

    if (pageKey === 'contact') {
      jsonLd.push(buildLocalBusinessSchema(locale));
    }

    const faqSet = PAGE_FAQ[pageKey];
    if (faqSet) {
      const lang = locale === 'ar' ? 'ar' : 'en';
      jsonLd.push(buildFaqSchema(faqSet[lang]));
    }

    return {
      ...seo,
      path,
      locale,
      jsonLd,
      includeSiteSchemas: pageKey === 'home',
    };
  }, [pageKey, path, locale, breadcrumbs]);
};
